import { Paper, Tab, Tabs } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

export default function UsersLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const value = location.pathname.includes('/users/devices')
    ? 'devices'
    : location.pathname.includes('/users/access-profiles')
      ? 'access-profiles'
      : 'list';

  const handleChange = (_event: React.SyntheticEvent, nextValue: string) => {
    navigate(nextValue === 'devices'
      ? '/users/devices'
      : nextValue === 'access-profiles'
        ? '/users/access-profiles'
        : '/users');
  };

  return (
    <>
      <Paper sx={{ mb: 3 }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Пользователи" value="list" />
          <Tab label="Устройства" value="devices" />
          <Tab label="Профили доступа" value="access-profiles" />
        </Tabs>
      </Paper>
      <Outlet />
    </>
  );
}
